'use strict';

// === SavageNav: Sticky header scroll behavior ===
(function SavageNav() {
  var header = document.querySelector('.site-header');
  if (!header) return;

  function onScroll() {
    header.classList.toggle('scrolled', window.scrollY > 80);
  }
  window.addEventListener('scroll', onScroll, { passive: true });
  onScroll();
})();

// === SavageMobileMenu ===
(function SavageMobileMenu() {
  var overlay = document.querySelector('.mobile-menu-overlay');
  var panel = document.querySelector('.mobile-menu-panel');
  var openBtn = document.querySelector('.nav-hamburger');
  var closeBtn = document.querySelector('.mobile-menu-close');
  if (!overlay || !panel || !openBtn) return;

  function open() {
    overlay.classList.add('open');
    panel.classList.add('open');
    document.body.style.overflow = 'hidden';
    overlay.removeAttribute('aria-hidden');
    panel.removeAttribute('aria-hidden');
    openBtn.setAttribute('aria-expanded', 'true');
    if (closeBtn) closeBtn.focus();
  }

  function close() {
    overlay.classList.remove('open');
    panel.classList.remove('open');
    document.body.style.overflow = '';
    overlay.setAttribute('aria-hidden', 'true');
    panel.setAttribute('aria-hidden', 'true');
    openBtn.setAttribute('aria-expanded', 'false');
  }

  openBtn.addEventListener('click', open);
  if (closeBtn) closeBtn.addEventListener('click', close);
  overlay.addEventListener('click', function(e) { if (e.target === overlay) close(); });
  document.addEventListener('keydown', function(e) { if (e.key === 'Escape') close(); });

  // Close on nav link click
  panel.querySelectorAll('a').forEach(function(a) {
    a.addEventListener('click', close);
  });

  // Active link highlighting
  var currentPath = window.location.pathname;
  panel.querySelectorAll('.mobile-nav-link').forEach(function(link) {
    if (link.getAttribute('href') === currentPath) link.classList.add('active');
  });
})();

// === SavageCart: Shopify AJAX cart ===
(function SavageCart() {
  var drawerOverlay = document.querySelector('.cart-drawer-overlay');
  var drawerPanel = document.querySelector('.cart-drawer-panel');
  var drawerBody = document.querySelector('.cart-drawer-body');
  var drawerSubtotal = document.querySelector('.cart-drawer-subtotal');
  var cartBadge = document.querySelector('.cart-badge');

  if (!drawerOverlay) return;

  function openCart() {
    refreshCart();
    drawerOverlay.classList.add('open');
    drawerPanel.classList.add('open');
    document.body.style.overflow = 'hidden';
    drawerOverlay.removeAttribute('aria-hidden');
    drawerPanel.removeAttribute('aria-hidden');
  }

  function closeCart() {
    drawerOverlay.classList.remove('open');
    drawerPanel.classList.remove('open');
    document.body.style.overflow = '';
    drawerOverlay.setAttribute('aria-hidden', 'true');
    drawerPanel.setAttribute('aria-hidden', 'true');
  }

  document.querySelectorAll('.nav-cart-btn:not(.nav-hamburger), .open-cart-trigger').forEach(function(btn) {
    btn.addEventListener('click', openCart);
  });

  var cartClose = document.querySelector('.cart-drawer-close');
  if (cartClose) cartClose.addEventListener('click', closeCart);

  drawerOverlay.addEventListener('click', function(e) {
    if (e.target === drawerOverlay) closeCart();
  });

  document.addEventListener('keydown', function(e) {
    if (e.key === 'Escape' && drawerOverlay.classList.contains('open')) closeCart();
  });

  function money(cents) {
    return '$' + (cents / 100).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
  }

  function updateBadge(count) {
    if (!cartBadge) return;
    cartBadge.textContent = count;
    cartBadge.classList.toggle('visible', count > 0);
  }

  async function refreshCart() {
    try {
      var res = await fetch('/cart.js');
      var cart = await res.json();
      updateBadge(cart.item_count);
      renderCartItems(cart);
    } catch(e) {
      console.error('Cart fetch error', e);
    }
  }

  function renderCartItems(cart) {
    if (!drawerBody) return;

    if (cart.item_count === 0) {
      drawerBody.innerHTML =
        '<div class="cart-empty">' +
          '<p>Your cart is empty.</p>' +
          '<a href="/collections/all" class="btn btn-outline" onclick="' +
            'document.querySelector(\'.cart-drawer-overlay\').classList.remove(\'open\');' +
            'document.querySelector(\'.cart-drawer-panel\').classList.remove(\'open\');' +
            'document.body.style.overflow=\'\'">Browse the Shop</a>' +
        '</div>';
      if (drawerSubtotal) drawerSubtotal.textContent = '';
      return;
    }

    drawerBody.innerHTML = cart.items.map(function(item) {
      return '<div class="cart-item" data-key="' + item.key + '" data-variant="' + item.variant_id + '">' +
        '<img src="' + item.image + '" alt="' + item.title + '" class="cart-item__image" width="64" height="80" loading="lazy">' +
        '<div class="cart-item__info">' +
          '<p class="cart-item__title">' + item.product_title + '</p>' +
          (item.variant_title && item.variant_title !== 'Default Title' ? '<p class="cart-item__variant">' + item.variant_title + '</p>' : '') +
          '<p class="cart-item__price">' + money(item.final_line_price) + '</p>' +
          '<div class="cart-item__qty">' +
            '<button class="qty-btn qty-dec" aria-label="Decrease quantity" data-key="' + item.key + '" data-qty="' + (item.quantity - 1) + '">&#8722;</button>' +
            '<span class="qty-value">' + item.quantity + '</span>' +
            '<button class="qty-btn qty-inc" aria-label="Increase quantity" data-key="' + item.key + '" data-qty="' + (item.quantity + 1) + '">+</button>' +
          '</div>' +
        '</div>' +
        '<button class="cart-item__remove" aria-label="Remove item" data-key="' + item.key + '" data-qty="0">&#215;</button>' +
      '</div>';
    }).join('');

    if (drawerSubtotal) drawerSubtotal.textContent = 'Subtotal: ' + money(cart.total_price);

    drawerBody.querySelectorAll('[data-key][data-qty]').forEach(function(btn) {
      btn.addEventListener('click', async function(e) {
        var key = e.currentTarget.dataset.key;
        var qty = parseInt(e.currentTarget.dataset.qty, 10);
        await updateItem(key, qty);
      });
    });
  }

  async function updateItem(key, quantity) {
    try {
      await fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: key, quantity: quantity })
      });
      refreshCart();
    } catch(e) {
      console.error('Cart update error', e);
    }
  }

  window.SavageAddToCart = async function(variantId, quantity) {
    quantity = quantity || 1;
    try {
      var btn = document.querySelector('.add-to-cart-btn');
      if (btn) { btn.disabled = true; btn.textContent = 'Adding\u2026'; }

      await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: variantId, quantity: quantity })
      });

      await refreshCart();
      openCart();

      if (btn) {
        btn.textContent = 'Added!';
        btn.style.background = 'var(--color-success)';
        setTimeout(function() {
          btn.disabled = false;
          btn.textContent = 'Add to Cart';
          btn.style.background = '';
        }, 2000);
      }
    } catch(e) {
      console.error('Add to cart error', e);
      var btn = document.querySelector('.add-to-cart-btn');
      if (btn) { btn.disabled = false; btn.textContent = 'Add to Cart'; }
    }
  };

  refreshCart();
})();

// === SavageGallery: Filter tabs + lightbox ===
(function SavageGallery() {
  var filtersEl = document.querySelector('.gallery-filters');
  if (!filtersEl) return;

  var cards = document.querySelectorAll('.artwork-card');
  var lightbox = document.querySelector('.lightbox-overlay');
  var lightboxImg = document.querySelector('.lightbox-image');
  var lightboxTitle = document.querySelector('.lightbox-title');
  var lightboxMeta = document.querySelector('.lightbox-meta');
  var lightboxDesc = document.querySelector('.lightbox-desc');
  var lightboxStatus = document.querySelector('.lightbox-status');
  var lightboxShopLink = document.querySelector('.lightbox-shop-link');
  var lightboxClose = document.querySelector('.lightbox-close');

  filtersEl.querySelectorAll('.filter-btn').forEach(function(btn) {
    btn.addEventListener('click', function() {
      filtersEl.querySelectorAll('.filter-btn').forEach(function(b) {
        b.classList.remove('active');
        b.setAttribute('aria-selected', 'false');
      });
      btn.classList.add('active');
      btn.setAttribute('aria-selected', 'true');

      var filter = btn.dataset.filter;
      cards.forEach(function(card) {
        var type = card.dataset.type || '';
        var show = filter === 'all' || type === filter;
        card.classList.toggle('hidden', !show);
      });
    });
  });

  function openLightbox(card) {
    if (!lightbox) return;
    var img = card.querySelector('img');
    if (lightboxImg) { lightboxImg.src = img ? img.src : ''; lightboxImg.alt = img ? img.alt : ''; }
    if (lightboxTitle) lightboxTitle.textContent = card.dataset.title || '';
    if (lightboxMeta) lightboxMeta.textContent = [card.dataset.year, card.dataset.medium, card.dataset.dimensions].filter(Boolean).join(' \u00B7 ');
    if (lightboxDesc) lightboxDesc.textContent = card.dataset.description || '';

    var status = card.dataset.status;
    if (lightboxStatus) {
      var colorMap = { available: 'var(--color-success)', sold: 'var(--color-error)', 'not-for-sale': 'var(--color-text-muted)' };
      var labelMap = { available: 'Available', sold: 'Sold', 'not-for-sale': 'Not for Sale' };
      var dotColor = colorMap[status] || 'var(--color-text-muted)';
      var dotLabel = labelMap[status] || status;
      lightboxStatus.innerHTML = '<span style="display:inline-block;width:8px;height:8px;border-radius:50%;background:' + dotColor + ';margin-right:0.5rem"></span>' + dotLabel;
    }

    var productUrl = card.dataset.productUrl;
    if (lightboxShopLink) {
      if (productUrl && status === 'available') {
        lightboxShopLink.href = productUrl;
        lightboxShopLink.style.display = 'inline-flex';
      } else {
        lightboxShopLink.style.display = 'none';
      }
    }

    lightbox.classList.add('open');
    document.body.style.overflow = 'hidden';
    if (lightboxClose) lightboxClose.focus();
  }

  function closeLightbox() {
    if (lightbox) lightbox.classList.remove('open');
    document.body.style.overflow = '';
  }

  cards.forEach(function(card) {
    card.addEventListener('click', function() { openLightbox(card); });
    card.addEventListener('keydown', function(e) {
      if (e.key === 'Enter' || e.key === ' ') {
        e.preventDefault();
        openLightbox(card);
      }
    });
  });

  if (lightboxClose) lightboxClose.addEventListener('click', closeLightbox);
  if (lightbox) {
    lightbox.addEventListener('click', function(e) {
      if (e.target === lightbox) closeLightbox();
    });
  }
  document.addEventListener('keydown', function(e) {
    if (e.key === 'Escape' && lightbox && lightbox.classList.contains('open')) closeLightbox();
  });
})();

// === SavageProduct: Variant selector + add to cart ===
(function SavageProduct() {
  var variantBtns = document.querySelectorAll('.variant-btn[data-variant-id]');
  if (!variantBtns.length) return;

  var selectedVariantId = null;
  var priceEl = document.querySelector('.product-price');
  var addBtn = document.querySelector('.add-to-cart-btn');

  variantBtns.forEach(function(btn) {
    btn.addEventListener('click', function() {
      variantBtns.forEach(function(b) { b.classList.remove('selected'); });
      btn.classList.add('selected');
      selectedVariantId = btn.dataset.variantId;
      var price = btn.dataset.price;
      if (priceEl && price) {
        priceEl.textContent = '$' + (parseInt(price, 10) / 100).toFixed(2);
      }
    });
  });

  var firstAvailable = Array.from(variantBtns).find(function(b) { return b.dataset.available === 'true'; });
  if (firstAvailable) firstAvailable.click();

  document.querySelectorAll('.product-thumb').forEach(function(thumb) {
    thumb.addEventListener('click', function() {
      var mainImg = document.querySelector('.product-main-image');
      if (mainImg) mainImg.src = thumb.dataset.src;
      document.querySelectorAll('.product-thumb').forEach(function(t) {
        t.classList.remove('active');
        t.style.borderColor = 'var(--color-border)';
      });
      thumb.classList.add('active');
      thumb.style.borderColor = 'var(--color-accent)';
    });
  });

  if (addBtn) {
    addBtn.addEventListener('click', function() {
      if (!selectedVariantId) return;
      if (window.SavageAddToCart) window.SavageAddToCart(selectedVariantId, 1);
    });
  }
})();

// === SavageCommissionForm: conditional fields ===
(function SavageCommissionForm() {
  var form = document.querySelector('.commission-form');
  if (!form) return;

  var sizeSelect = form.querySelector('[name="contact[Size]"]');
  var customSizeField = form.querySelector('.custom-size-field');
  if (sizeSelect) {
    sizeSelect.addEventListener('change', function() {
      if (customSizeField) {
        customSizeField.style.display = sizeSelect.value === 'custom' ? 'block' : 'none';
      }
    });
  }

  var timelineSelect = form.querySelector('[name="contact[Timeline]"]');
  var dateField = form.querySelector('.occasion-date-field');
  if (timelineSelect) {
    timelineSelect.addEventListener('change', function() {
      if (dateField) {
        dateField.style.display = timelineSelect.value === 'special-occasion' ? 'block' : 'none';
      }
    });
  }
})();

// === SavageScrollReveal: Intersection Observer ===
(function SavageScrollReveal() {
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

  var els = document.querySelectorAll('.reveal');
  if (!els.length) return;

  if (!window.IntersectionObserver) {
    els.forEach(function(el) { el.classList.add('revealed'); });
    return;
  }

  var observer = new IntersectionObserver(function(entries) {
    entries.forEach(function(entry) {
      if (entry.isIntersecting) {
        entry.target.classList.add('revealed');
        observer.unobserve(entry.target);
      }
    });
  }, { threshold: 0.1, rootMargin: '-50px' });

  els.forEach(function(el) { observer.observe(el); });
})();

// === SavageCartPage: quantity update + remove ===
(function SavageCartPage() {
  var cartForm = document.querySelector('.cart-page-form');
  if (!cartForm) return;

  cartForm.querySelectorAll('.cart-qty-input').forEach(function(input) {
    input.addEventListener('change', function() {
      var key = input.dataset.key;
      var qty = parseInt(input.value, 10);
      if (isNaN(qty) || qty < 0) return;

      fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: key, quantity: qty })
      }).then(function() {
        window.location.reload();
      }).catch(function(e) {
        console.error('Cart page update error', e);
      });
    });
  });

  cartForm.querySelectorAll('.cart-page-remove').forEach(function(btn) {
    btn.addEventListener('click', function(e) {
      e.preventDefault();
      var key = btn.dataset.key;

      fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: key, quantity: 0 })
      }).then(function() {
        window.location.reload();
      }).catch(function(e) {
        console.error('Cart page remove error', e);
      });
    });
  });
})();

// === SavageCollectionSort: sort-by dropdown ===
(function SavageCollectionSort() {
  var sortSelect = document.querySelector('.sort-select');
  if (!sortSelect) return;

  sortSelect.addEventListener('change', function() {
    var url = new URL(window.location.href);
    url.searchParams.set('sort_by', sortSelect.value);
    window.location.href = url.toString();
  });
})();

// === SavageEmailCapture: prototype form handler ===
(function SavageEmailCapture() {
  var emailForm = document.querySelector('.email-capture-form');
  if (!emailForm) return;

  emailForm.addEventListener('submit', function(e) {
    e.preventDefault();
    var input = emailForm.querySelector('input[type="email"]');
    var email = input ? input.value.trim() : '';
    if (!email) return;

    // Replace with Klaviyo or other provider integration
    // Example: POST to /contact with newsletter hidden field
    var btn = emailForm.querySelector('button[type="submit"]');
    if (btn) {
      var orig = btn.textContent;
      btn.textContent = 'Subscribed!';
      btn.disabled = true;
      setTimeout(function() {
        btn.textContent = orig;
        btn.disabled = false;
        if (input) input.value = '';
      }, 3000);
    }
  });
})();
